<template>
    <div class="flex gap-4 my-5">
        <hts-card-static
            type="success"
            color="success"
            data-number="20.8k"
            rate="12%"
            :datasets="successDatasets"
            :labels="labels"
            :chart-options="chartOptions"
            :title="$t('labels.revenue')" />
        <hts-card-static
            type="error"
            color="error"
            data-number="26.4k"
            rate="2%"
            :datasets="errorDatasets"
            :labels="labels"
            :chart-options="chartOptions"
            :title="$t('labels.cost')" />
        <hts-card-static
            type="success"
            color="success"
            data-number="3m 52s"
            rate="2%"
            :datasets="successDatasets"
            :labels="labels"
            :chart-options="chartOptions"
            :title="$t('labels.profit')" />
    </div>
</template>
<script lang="ts" setup>
const successDatasets = [
  {
    label: 'Data One',
    borderColor: '#12B76A',
    data: [10, 40, 20, 60],
    lineTension: 0.5,
    pointRadius: 0
  }
]
const errorDatasets = [
  {
    label: 'Data One',
    borderColor: '#F04438',
    data: [60, 10, 40, 5],
    lineTension: 0.5,
    pointRadius: 0
  }
]
const labels = ['example 1', 'example 2', 'example 3', 'example 4']
const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      display: false
    },
    y: {
      display: false
    }
  }
}
</script>
